export class ApiError extends Error {
	constructor(
		message: string,
		public status: number,
	) {
		super(message);
		this.name = "ApiError";
	}
}

const API_KEY_STORAGE_KEY = "flow-api-key";

export function getApiKey(): string | null {
	return localStorage.getItem(API_KEY_STORAGE_KEY);
}

export class NmblrFlowApiClient {
	constructor(private baseUrl = "/api/v1") {}

	async get<T>(path: string): Promise<T> {
		return this.request<T>("GET", path);
	}

	async post<T>(path: string, body: unknown): Promise<T> {
		return this.request<T>("POST", path, body);
	}

	async put<T>(path: string, body: unknown): Promise<T> {
		return this.request<T>("PUT", path, body);
	}

	async delete(path: string): Promise<void> {
		const res = await fetch(`${this.baseUrl}${path}`, {
			method: "DELETE",
			headers: this.headers(),
		});
		if (!res.ok) {
			const text = await res.text().catch(() => "Unknown error");
			throw new ApiError(text, res.status);
		}
	}

	private headers(body?: unknown): Record<string, string> {
		const h: Record<string, string> = {};
		const key = getApiKey();
		if (key) h["X-API-Key"] = key;
		if (body !== undefined) h["Content-Type"] = "application/json";
		return h;
	}

	private async request<T>(method: string, path: string, body?: unknown): Promise<T> {
		const res = await fetch(`${this.baseUrl}${path}`, {
			method,
			headers: this.headers(body),
			body: body !== undefined ? JSON.stringify(body) : undefined,
		});
		if (!res.ok) {
			const data = await res.json().catch(() => ({ error: "Unknown error" }));
			throw new ApiError(data.error ?? `Request failed: ${res.status}`, res.status);
		}
		return res.json() as Promise<T>;
	}
}

export const api = new NmblrFlowApiClient();
